'use strict';

var Sugar = require('sugar-core'),
    _dateOptions = require('./var/_dateOptions');

module.exports = Sugar.Date.getOption;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/getOption.js
// module id = 500
// module chunks = 0